import React, { useMemo, useCallback } from "react";
import WindowPattern from "./patterns/PatternSelector";

const DoubleHungDiagram = ({
  selectedValue,
  availableOptions,
  onChange,
  mode,
  disabled,
  formData,
  allAvailableOptions,
}) => {
  // Map option names to IDs
  const topSashOption = availableOptions?.find((opt) =>
    opt.name.toLowerCase().includes("top sash")
  );
  const bottomSashOption = availableOptions?.find((opt) =>
    opt.name.toLowerCase().includes("bottom sash")
  );
  const bothSashesOption = availableOptions?.find((opt) =>
    opt.name.toLowerCase().includes("both sash")
  );

  // Build cycle order: top → bottom → both → off
  const cycleOrder = useMemo(() => {
    if (mode === "grid" || mode === "obscurity") {
      return [
        topSashOption?.id,
        bottomSashOption?.id,
        bothSashesOption?.id,
        null,
      ];
    }
    return [];
  }, [mode, topSashOption, bottomSashOption, bothSashesOption]);

  const filteredCycleOrder = useMemo(() => {
    return cycleOrder.filter((id) => id !== undefined);
  }, [cycleOrder]);

  const topSelected =
    selectedValue === topSashOption?.id ||
    selectedValue === bothSashesOption?.id;
  const bottomSelected =
    selectedValue === bottomSashOption?.id ||
    selectedValue === bothSashesOption?.id;

  // Single click handler that cycles through options
  const handleClick = useCallback(() => {
    if (disabled || mode === "display") return;

    const currentIndex = filteredCycleOrder.indexOf(selectedValue);
    const nextIndex =
      currentIndex === -1 || currentIndex === filteredCycleOrder.length - 1
        ? 0
        : currentIndex + 1;
    onChange(filteredCycleOrder[nextIndex]);
  }, [disabled, mode, filteredCycleOrder, selectedValue, onChange]);

  // Get grid style name for pattern
  const selectedGridStyle = allAvailableOptions?.grid_styles?.find(
    (style) => style.id === formData?.grid_style_id
  );

  return (
    <div className="flex justify-center items-center">
      <div>
        <div
          className={`
            w-52 h-36 relative flex-1 bg-light border-8 border-brand
            ${disabled ? "opacity-50" : ""}
          `}
          style={{
            borderBottomWidth: "4px",
          }}
          onClick={handleClick}
        >
          <WindowPattern
            mode={mode}
            isSelected={topSelected}
            gridStyleName={selectedGridStyle?.name}
          />
        </div>

        <div
          className={`
            w-52 h-36 relative flex-1 bg-light border-8 border-brand
            ${disabled ? "opacity-50" : ""}
          `}
          style={{
            borderTopWidth: "4px",
          }}
          onClick={handleClick}
        >
          <WindowPattern
            mode={mode}
            isSelected={bottomSelected}
            gridStyleName={selectedGridStyle?.name}
          />
        </div>
      </div>
    </div>
  );
};

export default DoubleHungDiagram;
